// 字體基準（accessibility 規範）
// 對應 PRD §10.1 字體大小、§10.2 對比、§10.3 觸控目標
//
// 全專案文字一律從這裡取 style，避免到處寫死像素值。
// 規則摘要：
// - 比一般遊戲大 30%
// - 主要顯示文字 ≥ 18px
// - 動作按鈕文字 ≥ 24px
// - 結算頁台數明細 ≥ 22px
// - 對比 ≥ 4.5:1（透過白底 / 深底搭配 + 描邊）

import type Phaser from 'phaser';

/** Phaser Text 用的 style alias 縮寫。 */
type TTextStyle = Phaser.Types.GameObjects.Text.TextStyle;

/**
 * 預設字體設定。
 *
 * - sans-serif：依瀏覽器 fallback（macOS 為 PingFang TC、Windows 為 Microsoft JhengHei）
 * - 描邊：深底亮字 / 亮底深字 都加描邊提升對比
 */
export const FONT_STYLES = {
  /** 一般顯示文字（提示、副標題、説明） */
  body: {
    fontFamily: 'sans-serif',
    fontSize: '20px', // ≥ 18px
    color: '#ffffff',
    stroke: '#000000',
    strokeThickness: 2,
  },

  /** 大標題（首頁、結算結果） */
  title: {
    fontFamily: 'sans-serif',
    fontSize: '48px',
    fontStyle: 'bold',
    color: '#fff5d6',
    stroke: '#3a1c0a',
    strokeThickness: 6,
  },

  /** 動作按鈕（吃／碰／槓／胡／聽 等） */
  button: {
    fontFamily: 'sans-serif',
    fontSize: '28px', // ≥ 24px
    fontStyle: 'bold',
    color: '#ffffff',
    stroke: '#000000',
    strokeThickness: 3,
  },

  /** 結算頁台數明細（每一台一行） */
  result: {
    fontFamily: 'sans-serif',
    fontSize: '24px', // ≥ 22px
    color: '#ffffff',
    stroke: '#000000',
    strokeThickness: 2,
  },

  /** 風位 / 莊家標籤 */
  windLabel: {
    fontFamily: 'sans-serif',
    fontSize: '32px',
    fontStyle: 'bold',
    color: '#ffffff',
    stroke: '#000000',
    strokeThickness: 4,
  },

  /** 倒數警告（最後 5 秒變紅，PRD §9.6） */
  timerWarning: {
    fontFamily: 'sans-serif',
    fontSize: '22px',
    fontStyle: 'bold',
    color: '#ff5546',
    stroke: '#000000',
    strokeThickness: 2,
  },
} as const satisfies Record<string, TTextStyle>;

/** 觸控目標最小尺寸（PRD §10.3）。 */
export const MIN_TOUCH_TARGET = 88;

/** 牌與牌間距最小值（PRD §10.3 避免誤觸）。 */
export const MIN_TILE_GAP = 4;
